import { render } from "./TopPerformers.vue?vue&type=template&id=22f8f880&ts=true"
import script from "./TopPerformers.vue?vue&type=script&lang=ts"
export * from "./TopPerformers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__